import Imatge from 'components/corporatiu/Imatge';
import styles from './destacatshomemarato.module.scss';
import Enllac from 'components/corporatiu/Enllac/index.js';
import __isEmpty from 'lodash/isEmpty';

const DestacatsHomeMarato = (props) => {
    const { lang = 'es' } = props;

    const textsES = {
        marato: 'La Marató de 3Cat',
        fundacio: 'Fundació La Marató de 3Cat',
        investigacio: 'Investigación',
        projectes: 'Proyectos',
        fons: 'Fondos recaudados',
        transparencia: 'Transparencia'
    };
    const textsEN = {
        marato: 'La Marató de 3Cat',
        fundacio: 'Fundació La Marató de 3Cat',
        investigacio: 'Research',
        projectes: 'Projects',
        fons: 'Funds raised',
        transparencia: 'Transparency'
    };

    const texts = lang === 'es' ? textsES : textsEN;
    const idioma = `${lang}/`;
    return (
        <div className={styles.destacatsHomeMarato}>
            <Enllac className={styles.boto} href={`/tv3/marato/${idioma}que-es-la-marato/`}>
                <Imatge
                    src='https://statics.3cat.cat/recursos/marato/img/logos/logo-lamarato_blanc.svg'
                    alt=''
                    aria-hidden='true'
                    width={206}
                    height={40}
                />
                <span>{texts.marato}</span>
            </Enllac>
            <Enllac className={styles.boto} href={`/tv3/marato/${idioma}fundacio/`}>
                <Imatge
                    src='https://statics.3cat.cat/recursos/marato/img/logos/logo-fundacio30_monocrom_W.svg'
                    alt=''
                    aria-hidden='true'
                    width={206}
                    height={66}
                />
                <span>{texts.fundacio}</span>
            </Enllac>
            <Enllac className={styles.boto} href={`/tv3/marato/${idioma}recerca/`}>
                <Imatge
                    src='https://statics.3cat.cat/recursos/marato/img/ico_investigacio.png'
                    alt=''
                    aria-hidden='true'
                    width={67}
                    height={67}
                />
                <span>{texts.investigacio}</span>
            </Enllac>
            <Enllac className={styles.boto} href={`/tv3/marato/${idioma}recerca/projectes-financats/`}>
                <Imatge
                    src='https://statics.3cat.cat/recursos/marato/img/ico_projectes.png'
                    alt=''
                    aria-hidden='true'
                    width={67}
                    height={67}
                />
                <span>{texts.projectes}</span>
            </Enllac>
            <Enllac className={styles.boto} href={`/tv3/marato/${idioma}fundacio/`}>
                <Imatge
                    src='https://statics.3cat.cat/recursos/marato/img/ico_fons.png'
                    alt=''
                    aria-hidden='true'
                    width={67}
                    height={67}
                />
                <span>{texts.fons}</span>
            </Enllac>
            <Enllac className={styles.boto} href={`/tv3/marato/fundacio/transparencia/`}>
                <Imatge
                    src='https://statics.3cat.cat/recursos/marato/img/ico_transparencia.png'
                    alt=''
                    aria-hidden='true'
                    width={67}
                    height={67}
                />
                <span>{texts.transparencia}</span>
            </Enllac>
        </div>
    );
};

export default DestacatsHomeMarato;
